import { createReducer, on } from "@ngrx/store";
import { ChargerStatisticsState } from "./charger.statistics.models";
import * as chargerStatisticsActions from "./charger.statistics.actions";

export const initialChargerStatisticsState: ChargerStatisticsState = {
    chargerId: null,
    loading: false,
    error: null,
    data: null
}

export const chargerStatisticsReducer = createReducer(
    initialChargerStatisticsState,
    on(chargerStatisticsActions.loadChargerStatistics, (state, { chargerId }) => ({
        ...state,
        loading: true,
        chargerId
    })),
    on(chargerStatisticsActions.loadChargerStatisticsSuccess, (state, {chargerStatistics}) => ({
        ...state,
        loading: false,
        data: chargerStatistics
    })),
    on(chargerStatisticsActions.loadChargerStatisticsFailure, (state, {error}) => ({
        ...state,
        loading:false,
        error: error.errorMessage ?? "ERROR"
    }))
)